/* eslint-disable react/jsx-max-depth */
/* eslint-disable no-nested-ternary */
import { Burger, Flex, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { analytics } from '../../../../utils/firebase';
import Banner from '../../../elements/Banner';
import MenuDropdown from '../../../elements/MenuDropdown';
import IconArrowDown from '../../../icons/IconArrowDown';
import IconLogout from '../../../icons/IconLogout';
import { IconProfile } from '../../../icons/IconProfile';
import { RenderIconBreadcrumbs } from '../PageBase';
import IconToastr from './IconToastr';
import styles from './styles.scoped.css';
import { logEvent } from 'firebase/analytics';

function HeaderLayout({
  opened,
  theme,
  setOpened,
  dataDetailUser,
  bcs,
  toastr,
  setModal,
  // pathname = '',
}) {
  const navigate = useNavigate();
  const matchesMobile = useMediaQuery('(max-width: 768px)');
  const listSettings = [
    {
      name: 'Profil',
      onClick: () => {
        navigate('/profile');
      },
      icon: <IconProfile className={styles.iconProfile} />,
    },
    {
      name: 'Log out',
      onClick: () => {
        logEvent(analytics, 'click_logout', {
          from_path: location.pathname,
        });
        setModal(true);
      },
      icon: <IconLogout className={styles.iconLogout} />,
    },
  ];
  matchesMobile &&
    listSettings.unshift({
      name: (
        <div className={styles.row}>
          <span>{dataDetailUser.email}</span>
          <small>{dataDetailUser.name}</small>
        </div>
      ),
    });

  const showNameBreadcrumb = (idx, value) => {
    if (matchesMobile && idx !== bcs.length - 1) {
      return '...';
    } else if (value.name) {
      return value.name;
    } else {
      return value;
    }
  };

  return (
    <>
      <div
        className={styles.header}
        height={{ base: matchesMobile ? 100 : 110 }}
        hidden={opened}
      >
        <div className={styles.topContainer}>
          {matchesMobile && (
            <div>
              <Burger
                className={styles.menuIcon}
                color={theme?.colors?.dark[6]}
                mr="xl"
                onClick={() => setOpened((o) => !o)}
                opened={opened}
                size="md"
              />
            </div>
          )}
          <div className={styles.profileContainer}>
            {!matchesMobile && (
              <div>
                <div className={styles.row}>
                  <span>{dataDetailUser.email}</span>
                  <small>{dataDetailUser.name}</small>
                </div>
              </div>
            )}
            <MenuDropdown listDropDown={listSettings} position="bottom-end">
              <IconArrowDown />
            </MenuDropdown>
          </div>
        </div>
        <div className={styles.breadcrumbs}>
          <span>{<RenderIconBreadcrumbs />}</span>
          {bcs.map((item, index) => {
            return (
              <Flex key={index}>
                <Link to={item.to}>{showNameBreadcrumb(index, item)}</Link>
                {bcs.length > 1 && index < bcs.length - 1 && (
                  <Text key={index}>&nbsp;/&nbsp;</Text>
                )}
              </Flex>
            );
          })}
        </div>
      </div>
      {toastr?.visible ? (
        <div className={styles.alert}>
          <Banner {...toastr} icon={<IconToastr type={toastr.type} />} />
        </div>
      ) : null}
    </>
  );
}

export default HeaderLayout;

HeaderLayout.propTypes = {
  bcs: PropTypes.array,
  dataDetailUser: PropTypes.object,
  opened: PropTypes.bool,
  pathname: PropTypes.string,
  setModal: PropTypes.func,
  setOpened: PropTypes.func,
  theme: PropTypes.object,
  toastr: PropTypes.bool,
};
